'use client'
import AppRouterGlobalHeadTags from './app-router'
import PagesRouterGlobalHeadTags from './pages-router'

export { AppRouterGlobalHeadTags }
export default PagesRouterGlobalHeadTags
